/* eslint-disable no-console */
import axios from 'axios';
import config from './config/config';
import router from '../router';
import store, { resetState } from '../store/store';

const HTTP = axios.create();

HTTP.interceptors.request.use(
  (request) => {
    request.headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${store.getters['user/token']}`,
    };
    if (request.url.indexOf('http') === -1) {
      request.url = config.BASE_URL_API + request.url;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor
HTTP.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response?.status === 401) {
    resetState();
    router.push({ name: 'connexion' });
    router.go(0);
  }
  if (!error.response) {
    console.error('[Axios Interceptor] Pas de response (peut-être une erreur réseau ou taille du fichier ?)');
    console.error('[Axios Error]', {
      message: error.message,
      response: error.response,
      request: error.request,
    });
  }
  throw error;
});

export default HTTP;
